import React, {useState} from "react";
import {Button, Form, Input} from "antd";

interface IResetPasswordFormProps {
  onSubmit: (values: any) => Promise<any>;
}

export default function ResetPasswordForm(props: IResetPasswordFormProps): JSX.Element {
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async function (values: any) {
    setSubmitting(true);
    try {
      await props.onSubmit(values);
      form.resetFields();
    } catch (error) {
      // do nothing
    }
    setSubmitting(false);
  };

  return (
    <Form form={form} onFinish={onFinish} style={{width: 300}}>
      <Form.Item name="email" rules={[{required: true, message: "Please input your email"}]}>
        <Input type="email" placeholder="Email" size="large" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={submitting} style={{width: "100%"}} size="large">
          Reset password
        </Button>
      </Form.Item>
    </Form>
  );
}
